import { frontendURL } from 'dashboard/helper/URLHelper';
import FlowsList from './FlowsList.vue';
import FlowBuilder from './FlowBuilder.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'flows_list',
    component: FlowsList,
    meta: {
      permissions: ['administrator', 'flow_manage'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId'),
    name: 'flow_builder',
    component: FlowBuilder,
    meta: {
      permissions: ['administrator', 'flow_manage'],
    },
  },
];
